const faqData = [
  {
    id: "faq-1",
    question: "Quem pode participar da promoção? ",
    answer: [
      "Pessoas físicas maiores de 18 anos, com CPF válido e residentes no Brasil.",
      "NÃO PODEM participar dessa promoção: ",
      "Empresas (pessoas jurídicas);",
      "Funcionários da empresa;",
      "Familiares diretos."
    ]
  },
  {
    id: "faq-2",
    question: "Qual é o período de participação da promoção? ",
    answer: "De 10 de março de 2025 a 31 de dezembro de 2025."
  },
  {
    id: "faq-3",
    question: "Quais locais estão participando da promoção? ",
    answer: [
      "Todas as lojas físicas Cobasi, Pet & Fácil Cobasi e Mundo Pet;",
      "Site cobasi.com.br; ",
      "Aplicativo Cobasi;",
      "Todos os estabelecimentos que emitam nota fiscal em nome da Cobasi."
    ]
  },
  {
    id: "faq-4",
    question: "Qual é a área de abrangência da promoção? ",
    answer: "Todo o Brasil. "
  },
  {
    id: "faq-5",
    question: "Preciso comprar algo para participar?",
    answer:
      "Sim, os participantes devem estar cadastrados no programa Amigo Cobasi e realizar compras a partir de R$ 149,00 no mesmo cupom fiscal para obter um número da sorte. "
  },
  {
    id: "faq-6",
    question: "Como faço para participar? ",
    answer: [
      "Cadastre-se no programa Amigo Cobasi; ",
      "Realize compras a partir de R$ 149,00 no mesmo cupom fiscal;",
      `Inscreva-se na promoção pelo site <a href="//www.promocobasi40.com.br" target="_blank">www.promocobasi40.com.br</a> `,
      "Cadastre suas compras feitas dentro do período da promoção. "
    ]
  },
  {
    id: "faq-7",
    question:
      "Depois de me cadastrar, as compras geram os números da sorte automaticamente?",
    answer:
      "Sim, desde que você informe o CPF inscrito no Amigo Cobasi no momento da compra. "
  },
  {
    id: "faq-8",
    question: "Como ganhar o número da sorte extra?",
    answer:
      "Se você tiver uma compra programada ativa durante a promoção e fizer uma compra de pelo menos R$ 149,00, você ganha um número da sorte extra. Fica limitado a 1 (um) número da sorte extra por cupom. "
  },
  {
    id: "faq-9",
    question: "Não estou conseguindo me cadastrar, o que faço? ",
    answer: `Entre em contato com o SAC Cobasi pelo telefone (11) 3831-8999 (segunda a sábado, das 8h às 20h) ou pelo <a href="https://atendimento.cobasi.com.br/hc/pt-br/requests/new?ticket_form_id=10972792826523" target="_blank">e-mail</a>.`
  },
  {
    id: "faq-10",
    question: "Existe um limite de participação? ",
    answer:
      "Sim. Cada participante pode acumular até 250 números da sorte e ganhar apenas uma vez. "
  },
  {
    id: "faq-11",
    question: "Onde vejo meus números da sorte?  ",
    answer: `No site <a href="//www.promocobasi40.com.br" target="_blank">www.promocobasi40.com.br</a> na área de login do participante.`
  },
  {
    id: "faq-12",
    question: "Quais são as datas dos sorteios e os prêmios? ",
    answer: [
      "Os prêmios consistem em 1 ano de compras na Cobasi (equivalente a R$ 345,00 por mês, depositados em uma única parcela). ",
      "Os sorteios serão realizados mensalmente conforme as datas abaixo:",
      "10/04/2025: 3 premiados;",
      "08/05/2025: 5 premiados;",
      "05/06/2025: 4 premiados;",
      "10/07/2025: 4 premiados;",
      "07/08/2025: 5 premiados;",
      "11/09/2025: 4 premiados;",
      "09/10/2025: 5 premiados;",
      "06/11/2025: 4 premiados;",
      "11/12/2025: 4 premiados;",
      "08/01/2026: 5 premiados;"
    ]
  },
  {
    id: "faq-13",
    question: "Como saberei se fui um dos ganhadores? ",
    answer: `Os ganhadores serão divulgados no site <a href="//www.promocobasi40.com.br" target="_blank">www.promocobasi40.com.br</a> e avisados por e-mail, telefone ou WhatsApp. `
  },
  {
    id: "faq-14",
    question: "Como recebo meu prêmio? ",
    answer: "O valor será creditado em pontos no Programa Amigo Cobasi. "
  },
  {
    id: "faq-15",
    question: "Posso trocar meu prêmio por dinheiro? ",
    answer:
      "Não. A lei não permite que prêmios de sorteios sejam pagos em dinheiro. "
  },
  {
    id: "faq-16",
    question: "Tenho mais dúvidas, o que faço?",
    answer: `Fale com o SAC Cobasi pelo telefone (11) 3831-8999 ou pelo <a href="https://atendimento.cobasi.com.br/hc/pt-br/requests/new?ticket_form_id=10972792826523" target="_blank">e-mail</a>.`
  },
  {
    id: "faq-17",
    question: "Posso alterar minhas informações após realizar meu cadastro? ",
    answer:
      "Depois que o cadastro pessoal foi concluído, você não pode alterar nome e sobrenome, CPF e data de nascimento. "
  },
  {
    id: "faq-18",
    question: "O que é documento fiscal? ",
    answer: "Documento fiscal = Cupom Fiscal ou Nota Fiscal da compra. "
  },
  {
    id: "faq-19",
    question:
      "Posso alterar as informações de um documento fiscal que já cadastrei? ",
    answer:
      "Não será possível alterar os dados informados depois que o documento fiscal for registrado. "
  },
  {
    id: "faq-20",
    question: "Quais são os prêmios ofertados na promoção? ",
    answer:
      "O prêmio consiste em 1 ano de compras em lojas Cobasi, exclusivamente através de pontos do Programa Amigo Cobasi, limitado ao valor de R$ 345,00 em pontos por mês, durante o período de 12 meses. Validade 12 meses. Serão ao todo 43 prêmios sorteados na promoção. "
  },
  {
    id: "faq-21",
    question:
      "Caso eu seja um ganhador, quais documentos serão necessários para receber o prêmio?",
    answer:
      "Será necessário enviar cópia do RG/CPF ou CNH, comprovante de residência atual e, também, retornar assinado o recibo de entrega do prêmio."
  },
  {
    id: "faq-22",
    question: "Poderá ocorrer a desclassificação de participantes?",
    answer: [
      "Sim, caso haja desacordo com quaisquer das regras previstas em regulamento. Sendo tais:",
      "Que esteja em desacordo com QUALQUER ITEM elencado neste regulamento; ",
      "Que cometer qualquer tipo de fraude devidamente comprovada ou atos ilícitos comprovados (hackers, crackers, etc...), e que praticar conduta que possa alterar o regular resultado da promoção, podendo ainda responder civil e criminalmente pelos seus atos, em conformidade com a legislação vigente no País;",
      "Que faça comunicação por qualquer meio, de palavras de baixo calão, de conteúdo obsceno ou ofensivo à(s) Promotora(s) e/ou a terceiros; ",
      "Que tente fraudar ou burlar as regras estabelecidas neste regulamento e/ou utilize meios mecânicos, robóticos, repetitivos, automáticos e/ou análogos, com intuito de reprodução automática e/ou repetitiva de cadastros, idênticos ou não, e/ou fraudulentos para interferir na promoção; ",
      "Que forneça informações de cadastro, falsas e/ou incorretas e/ou incompletas;",
      "Que tenha tido sua nota fiscal cancelada; ",
      "Que não enviar a documentação dentro do prazo solicitado neste regulamento para viabilização da entrega do prêmio;",
      "Que não apresente a nota fiscal ou ainda, a nota fiscal eletrônica quando solicitado pela(s) promotora(s) para verificação; ",
      "Que não esteja cadastrado(a) no programa Amigo Cobasi; ",
      "Que esteja incluído na relação das pessoas impedidas de participar da promoção; ",
      "Que tenha domicílio fora dos locais permitidos neste regulamento; ",
      "Que não tenha atingido o valor mínimo (R$149,00), após desconsiderados os valores de medicações, os quais são vetados da promoção; ",
      "Que apresente nota fiscal, que não possa ser confirmado mediante consulta aos órgãos governamentais através do código chave de 44 dígitos; ",
      "Que tenha cadastrado a mesma nota fiscal/cupom fiscal mais de uma vez ou de outro participante;",
      "Que tenha recebido número da sorte da chance extra e não tenha compra programada ATIVA no momento da apuração; ",
      "Que já tenha vencido uma vez; ",
      "Que não queira receber o prêmio, no prazo de 180 dias; ",
      "Que tenha solicitado a exclusão dos seus dados pessoais e/ou de identificação e/ou de participação no período compreendido pelo início da promoção até a entrega efetiva dos prêmios em caso de contemplação. "
    ]
  },
  {
    id: "faq-23",
    question: "Os dados pessoais que cadastrei na promoção estão seguros? ",
    answer:
      "Sim, seus dados estão protegidos, bem como seu tratamento será em conformidade com a Lei n° 13.709/2018, ou Lei Geral de Proteção dos Dados/LGPD. A Mandatária compromete-se ainda a não comercializar ou ceder, ainda que a título gratuito, os dados coletados em razão da promoção, nos termos do Artigo 11 da Portaria ME n° 7.638/2022. Maiores informações sobre este assunto podem ser verificadas no Item 15 – Disposições Gerais do Regulamento. "
  },
  {
    id: "faq-24",
    question:
      "Estou com problemas relacionados à emissão da minha nota fiscal, o que devo fazer? ",
    answer: `Caso tenha dificuldades para cadastrar sua nota fiscal ou identifique algum problema com a emissão da sua nota fiscal de compra, entre em contato com o CAC Cobasi pelo <a href="https://atendimento.cobasi.com.br/hc/pt-br/requests/new?ticket_form_id=10972792826523" target="_blank">e-mail</a> para receber orientações sobre como proceder.`
  }
];

export default faqData;
